module.exports = __webpack_public_path__ + "static/media/layer-icon.92645a59.svg";